import { render, staticRenderFns } from "./OrganizerForm.vue?vue&type=template&id=0927c6a0"
import script from "./OrganizerForm.vue?vue&type=script&lang=js"
export * from "./OrganizerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports